import Super from '@simplepractice/ember-messaging-client/models/messaging-message';

export default Super.extend({});
